module.exports = __webpack_public_path__ + "img/section2Logo5.d4307b11.png";